import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectAllLimits } from "./selectors";

export const useLimits = () => useSelector(selectAllLimits);

const getMaxLimitForCategory = (
  limits: Partial<Record<API.Limits.Type, API.Limits.Limit>>,
  transactionTypes: Array<string>,
) => {
  const minimums = Object.keys(limits)
    .filter((transactionType) =>
      transactionTypes.some((type) => transactionType.startsWith(type)),
    )
    .map((transactionType) => {
      if (limits[transactionType as API.Limits.Type]) {
        let categoryMin: number = Infinity;
        Object.entries(
          limits[transactionType as API.Limits.Type] || {},
        ).forEach(([key, val]) => {
          if (key === "amount_available") {
            return;
          }
          if ((val as API.Limits.Info).amount < categoryMin) {
            categoryMin = (val as API.Limits.Info).amount;
          }
        });
        return categoryMin === Infinity ? null : categoryMin;
      }
      return null;
    })
    .filter((amount): amount is number => amount !== null);
  return minimums.length > 0 ? Math.max(...minimums) : Infinity;
};

export const useMaximumAvailablePushAmount = () => {
  // Returns the maximum total limit amount. NOT limit remaining.
  // Limitation of this approach is that if let's say ach_push and fednow_send were both enabled
  // but only ach_push had limits, we would end up enforcing ach_push limits on fednow_send transfers.
  const limits = useLimits();
  return useMemo(() => {
    return getMaxLimitForCategory(limits, ["ach_push", "fednow_send"]);
  }, [limits]);
};

export const useMaximumAvailablePullAmount = () => {
  const limits = useLimits();
  return useMemo(() => {
    return getMaxLimitForCategory(limits, ["ach_pull"]);
  }, [limits]);
};

export const useMaximumFedNowAmount = () => {
  const limits = useLimits();
  return useMemo(() => {
    return getMaxLimitForCategory(limits, ["fednow_send"]);
  }, [limits]);
};
